import { Component, OnInit } from '@angular/core';
import { UserManager } from 'oidc-client';
import { AuthService } from 'src/app/Services/auth.service';
import { LoaderService } from 'src/app/Services/loader.service';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.css']
})
export class RedirectComponent implements OnInit {

  constructor(private authservice: AuthService, private loaderservice: LoaderService) {

    this.loaderservice.showLoader();
    let userManager = new UserManager(this.authservice.getClientSettings());
    userManager.signinRedirectCallback().then((user) => {
      window.history.replaceState({},
        window.document.title,
        window.location.origin);
        this.loaderservice.hideLoader();
        if(user && user.state)
        {
          window.location.href = "/KPIReports"+user.state;

        }else if(user)
        {
          window.location.href = window.location.origin+"/KPIReports/admin";
        }
        else{
          window.location.href = window.location.origin+"/KPIReports/home";
        }
    }, error => {
      console.error(error);
      this.loaderservice.hideLoader();
    });
  }

  ngOnInit() {
  }

}
